import { ACTIVE_SUBSCRIPTION_TYPES } from "@arbeidsark/shared"
import { useOrganizationMembership } from "../../utils/hooks/useOrganizationMembership"
import { useSubscriptionInfo } from "../../utils/hooks/useSubscriptionInfo"
import NewSubscriptionRequired from "./personal/NewSubscriptionRequired"
import SubscriptionPersonal from "./personal/SubscriptionPersonal"
import SubscriptionSchool from "./school/SubscriptionSchool"
import SubscriptionSchoolMember from "./school/SubscriptionSchoolMember"

export type SubscriptionProps = {}

const Subscription: React.FC<SubscriptionProps> = () => {
  const organizationMembership = useOrganizationMembership()
  const isOrganizationAdmin =
    organizationMembership?.role === "ADMIN" ||
    organizationMembership?.role === "OWNER"
  const subscription = useSubscriptionInfo()

  const subscriptionIsActive =
    ACTIVE_SUBSCRIPTION_TYPES.includes(subscription?.status ?? "") ?? false

  const renderSchoolSubscriptionPage = isOrganizationAdmin
  const renderSchoolMemberSubscriptionPage =
    !renderSchoolSubscriptionPage && organizationMembership
  const renderPersonalSubscriptionPage =
    !renderSchoolMemberSubscriptionPage && subscriptionIsActive
  const renderNewSubscriptionIsRequiredPage = !(
    renderPersonalSubscriptionPage ||
    renderSchoolMemberSubscriptionPage ||
    renderSchoolSubscriptionPage
  )

  return (
    <>
      {renderSchoolSubscriptionPage && <SubscriptionSchool />}
      {renderSchoolMemberSubscriptionPage && <SubscriptionSchoolMember />}
      {renderPersonalSubscriptionPage && (
        <SubscriptionPersonal subscription={subscription!} />
      )}
      {renderNewSubscriptionIsRequiredPage && <NewSubscriptionRequired />}
    </>
  )
}

export default Subscription
